var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 27.5938H13.8437C10.4375 27.5938 7.6875 30.3437 7.6875 33.75C7.6875 35.0937 7.96875 35.75 10.1562 36.2187C10.1562 36.2187 17.5 37.5 20 37.5C22.5 37.5 29.8438 36.2187 29.8438 36.2187C32.0313 35.75 32.3125 35.125 32.3125 33.75C32.2813 30.3437 29.5312 27.5938 26.1562 27.5938Z",
    fill: "url(#paint0_linear_536_2942)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 25V28.375C16.3125 30.4063 17.9687 32.0625 20 32.0625C22.0312 32.0625 23.6875 30.4063 23.6875 28.375V25.0312L16.3125 25Z",
    fill: "url(#paint1_linear_536_2942)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 10.4687C10.6562 17.1875 10.6562 17.0625 10.6562 17.125H20H29.3437C29.3437 17.0625 29.3437 17.1875 29.3437 10.4687C29.3437 -0.0312499 10.6562 -0.0312499 10.6562 10.4687Z",
    fill: "url(#paint2_radial_536_2942)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.2499C26.7501 27.2499 28.2501 21.8437 28.5626 19.2812C31.9376 19.1562 31.8751 14.0937 28.5626 14.0937C28.5626 13.3749 27.4063 9.21868 25.2188 9.24993C23.9063 9.24993 21.3126 10.1562 20.0001 10.1562C18.6876 10.1562 16.0938 9.24993 14.7813 9.24993C12.5938 9.21868 11.4376 13.3749 11.4376 14.0937C8.12505 14.0937 8.06255 19.1562 11.4376 19.2812C11.7501 21.8124 13.2501 27.2499 20.0001 27.2499Z",
    fill: "url(#paint3_radial_536_2942)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint4_linear_536_2942)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint5_linear_536_2942)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_2942",
    x1: 20,
    y1: 37.5,
    x2: 20,
    y2: 27.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC907E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_2942",
    x1: 20,
    y1: 32.074,
    x2: 20,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2094,
    stopColor: "#FEB4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4023,
    stopColor: "#FCA998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#F99787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7702,
    stopColor: "#F47C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#F27165"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_536_2942",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8386 3.39819) scale(25.3257 25.3257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.086496,
    stopColor: "#F5E5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C9A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_536_2942",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.64965 9.54753) scale(24.4079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4432,
    stopColor: "#FFB6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6343,
    stopColor: "#FFAF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    stopColor: "#FEA292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8946,
    stopColor: "#FD9182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9971,
    stopColor: "#FC7A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_536_2942",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_2942",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b3ebae3caf5552be7bde2790596b0414.svg";
export { ForwardRef as ReactComponent };